import React from 'react';
import '../style.css';

function Footer() {
  return (
    <footer className="footer-custom text-white text-center py-3">
      <a 
        href="https://www.muamul.com"  // Website link 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-white text-decoration-none"
      >
        © 2025 Muamul Technology | All rights reserved
      </a>
    </footer>
  );
}

export default Footer;
